webpackJsonp([227599198892374],{

/***/ 665:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>Seit der ISE 2016 puscht LG electronics OLED-Displays im professionellen und TV-Bereich durch viele Marketingmaßnahmen. Mitbewerber Samsung zeigte ebenfalls OLED-Displays, setzt jedoch neuerdings auf die 'Quantum Dot'-Technologie. Doch auch hochauflösende LED-Displays mit immer kleinerer Pixel-Pitch waren bei vielen Ausstellern auf diversen Messen und Roadshows zu sehen. Weiterlesen auf <a href=\"https://www.professional-system.de/basics/display-technologien-erklaert-lcd-led-oled-quantum-dot/\">professional-systems.de</a></p>","excerpt":"Seit der ISE 2016 puscht LG electronics OLED-Displays im professionellen und TV-Bereich durch viele…","frontmatter":{"title":"Display Technologien erklärt","date":"August 15, 2016","path":"/display-technologien","image":"/2016-08-15-disply-technologien.jpg"}}},"pathContext":{"prev":{"frontmatter":{"path":"/etha-partnertreffen"}},"next":{"frontmatter":{"path":"/tipo-de-producto"}}}}

/***/ })

});


// WEBPACK FOOTER //
// path---display-technologien-1df2138a96c37df665f5.js